export const fetchcart = async (customer_id) => {
  try {
    // Append customer_id as a query parameter
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/add-cart/?customer_id=${customer_id}`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};
